<template>
  <van-popup
    v-model:show="innerShow"
    position="right"
    :style="{ width: '100%', height: '100%' }"
  >
    <div class="i-part__content">
      <van-nav-bar
        :title="readonly ? '查看工时' : '选择工时'"
        left-text="返回"
        left-arrow
        @click-left="
          readonly = false;
          innerShow = false;
        "
      />
      <template v-if="!readonly">
        <form action="/">
          <van-search
            v-model="formData.keyword"
            @search="onSearch"
            placeholder="请输入搜索关键词"
          />
        </form>
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="formData.type_ids"
            :options="state.wageTypeOption"
            @change="dropdownChange"
          />
        </van-dropdown-menu>
        <div class="i-part__body">
          <van-card
            v-for="item in state.wageList"
            :key="item.id"
            :title="'工时名称：' + item.wage_name"
          >
            <template #tags>
              <van-tag style="margin-top: 5px" plain type="danger">{{
                item.type_name
              }}</van-tag>
            </template>
            <template #price>
              单价：¥ {{ item.price }}/{{ item.unit_name }}
            </template>
            <template #num>
              <van-stepper
                :min="0"
                v-model="wageNumberMap[item.id].number"
                theme="round"
                button-size="22"
                input-width="50px"
              />
            </template>
          </van-card>
        </div>
        <div style="height: 50px; padding: var(--van-submit-bar-padding)"></div>

        <van-submit-bar
          button-text="保存工时"
          @submit="onSubmit"
          button-color="#1989fa"
        />
      </template>
      <template v-else>
        <div class="i-part__body">
          <template v-for="item in wageNumberMap" :key="item.id">
            <van-card v-if="item.number" :title="'工时名称：' + item.wage_name">
              <template #tags>
                <van-tag style="margin-top: 5px" plain type="danger">{{
                  item.type_name
                }}</van-tag>
              </template>
              <template #price>
                单价：¥ {{ item.price }}/{{ item.unit_name }}
              </template>
              <template #num>
                <span style="font-size: 14px"> 数量：{{ item.number }} </span>
              </template>
            </van-card>
          </template>
        </div>
      </template>
    </div>
  </van-popup>
</template>
<script>
import { useVModel } from "@vueuse/core";
import { computed, reactive, ref } from "vue";
import { wageService } from "@/service";
export default {
  nam: "part",
  props: {
    default: {
      type: Object,
    },
    show: {
      type: Boolean,
      requried: true,
    },
  },
  setup(props, { emit }) {
    const readonly = ref(false);

    const openDetail = () => {
      readonly.value = true;
      emit("update:show", true);
    };

    const state = reactive({
      wageTypeOption: [{ text: "全部", value: "" }],
      wageList: [],
    });
    const formData = reactive({
      keyword: "",
      storage_id: "",
      type_ids: "",
    });
    // 分类
    const getWageTypeList = async () => {
      const { data } = await wageService.wageTypeList();
      state.wageTypeOption.push(
        ...data.map((item) => ({
          text: item.wage_type_name,
          value: item.id,
        }))
      );
    };
    getWageTypeList();
    const wageNumberMap = reactive(props.default);

    const getWageList = async () => {
      try {
        const { data } = await wageService.wageList(formData);
        data.forEach((item) => {
          wageNumberMap[item.id] = {
            number: wageNumberMap[item.id]?.number || 0,
            ...item,
          };
        });
        state.wageList = data;
      } catch (error) {
        state.wageList = [];
      }
    };
    getWageList();
    const dropdownChange = () => {
      getWageList();
    };

    const onSearch = () => {
      getWageList();
    };

    const totalPrice = computed(() => {
      return Object.values(wageNumberMap).reduce((parent, child) => {
        return parent + child.number;
      }, 0);
    });

    const onSubmit = () => {
      emit("submit", wageNumberMap);
    };
    return {
      onSearch,
      state,
      formData,
      dropdownChange,
      totalPrice,
      onSubmit,
      wageNumberMap,
      readonly,
      openDetail,
      innerShow: useVModel(props, "show", emit),
    };
  },
};
</script>
<style lang="less" scoped>
.i-part__content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.i-part__body {
  flex: 1;
  min-height: 0;
  overflow: auto;
}
</style>
